"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseModel_1 = require("./BaseModel");
var ConsigneeBalanceRequest;
(function (ConsigneeBalanceRequest) {
    var Create = (function (_super) {
        __extends(Create, _super);
        function Create() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.cod = undefined;
            _this.name = undefined;
            _this.balance = undefined;
            _this.qty = undefined;
            _this.data = undefined;
            return _this;
        }
        return Create;
    }(BaseModel_1["default"]));
    ConsigneeBalanceRequest.Create = Create;
    var Update = (function (_super) {
        __extends(Update, _super);
        function Update() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.cod = undefined;
            _this.name = undefined;
            _this.balance = undefined;
            _this.qty = undefined;
            _this.data = undefined;
            return _this;
        }
        return Update;
    }(BaseModel_1["default"]));
    ConsigneeBalanceRequest.Update = Update;
})(ConsigneeBalanceRequest = exports.ConsigneeBalanceRequest || (exports.ConsigneeBalanceRequest = {}));
var ConsigneeBalanceResponse;
(function (ConsigneeBalanceResponse) {
    var ConsigneeBalance = (function (_super) {
        __extends(ConsigneeBalance, _super);
        function ConsigneeBalance() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.cod = undefined;
            _this.name = undefined;
            _this.balance = undefined;
            _this.qty = undefined;
            _this.data = undefined;
            return _this;
        }
        return ConsigneeBalance;
    }(BaseModel_1["default"]));
    ConsigneeBalanceResponse.ConsigneeBalance = ConsigneeBalance;
})(ConsigneeBalanceResponse = exports.ConsigneeBalanceResponse || (exports.ConsigneeBalanceResponse = {}));



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/consigneeBalance.js
// module id = ../model/dist/models/consigneeBalance.js
// module chunks = main